module.exports = __webpack_public_path__ + "2b77dc681143edffecbd318973751af3.png";